export const filterTreeForSelected = (nodes) => {
  const filteredTree = []

  for (const node of nodes) {
    if (node.type === 'blob' && node.selected) {
      // If a file is selected, include it.
      filteredTree.push({ ...node })
    } else if (node.type === 'tree' && node.children) {
      // If it's a folder, recursively filter its children.
      const filteredChildren = filterTreeForSelected(node.children)

      // Only include the folder if it has selected descendants.
      if (filteredChildren.length > 0) {
        filteredTree.push({ ...node, children: filteredChildren })
      }
    }
  }

  return filteredTree
}

export const renderTree = (fileObject, indent = '') => {
  let output = ''
  const keys = Object.keys(fileObject)

  keys.forEach((key, index) => {
    const isLast = index === keys.length - 1
    const prefix = isLast ? '└── ' : '├── '
    const nestedIndent = isLast ? '    ' : '│   '
    const isDirectory = Object.keys(fileObject[key]).length > 0

    if (isDirectory) {
      output += `${indent}${prefix}${key}/\n`
      output += renderTree(fileObject[key], indent + nestedIndent)
    } else {
      output += `${indent}${prefix}${key}\n`
    }
  })

  return output
}

export const pathsToNestedObject = (paths) => {
  const root = {}

  for (const path of paths) {
    const parts = path.split('/')
    let currentLevel = root

    for (let i = 0; i < parts.length; i++) {
      const part = parts[i]
      if (!currentLevel[part]) {
        currentLevel[part] = {}
      }
      currentLevel = currentLevel[part]
    }
  }

  return root
}

// export const pathsToNestedObject = (paths) => {
//   const root = {}
//
//   for (const path of paths) {
//     const parts = path.split('/')
//     let currentLevel = root
//
//     for (let i = 0; i < parts.length; i++) {
//       const part = parts[i]
//       const isFile = i === parts.length - 1
//
//       if (!currentLevel[part]) {
//         currentLevel[part] = isFile ? {} : {} // Create as an empty object regardless
//       }
//       currentLevel = currentLevel[part]
//     }
//   }
//   return root
// }
//
// export const renderTree = (fileObject, indent = '', isRoot = true) => {
//   let output = ''
//   const keys = Object.keys(fileObject)
//
//   if (isRoot) {
//     const rootName = keys[0]
//     output += `${rootName}/\n`
//     return output + renderTree(fileObject[rootName], '', false)
//   }
//
//   keys.forEach((key, index) => {
//     const isLast = index === keys.length - 1
//     const prefix = isLast ? '└── ' : '├── '
//     const nestedIndent = isLast ? '    ' : '│   '
//
//     if (Object.keys(fileObject[key]).length > 0) { // It's a directory
//       output += `${indent}${prefix}${key}/\n`
//       output += renderTree(fileObject[key], indent + nestedIndent, false)
//     } else { // It's a file
//       output += `${indent}${prefix}${key}\n`
//     }
//   })
//
//   return output
// }

export const buildFileTree = (files) => {
  const tree = []
  const map = {}

  files.forEach((file) => {
    const parts = file.path.split('/')
    let currentLevel = tree
    let currentPath = ''

    parts.forEach((part, index) => {
      currentPath = currentPath ? `${currentPath}/${part}` : part
      let node = map[currentPath]

      if (!node) {
        const isFile = index === parts.length - 1 && file.type === 'blob'
        node = {
          id: currentPath,
          name: part,
          path: currentPath,
          type: isFile ? 'blob' : 'tree',
          children: isFile ? undefined : [],
          selected: false,
          indeterminate: false,
          size: file.size,
          content: isFile ? file.content : null
        }
        map[currentPath] = node
        currentLevel.push(node)
      }
      if (node.type === 'tree') {
        currentLevel = node.children
      }
    })
  })

  return tree
}

export const sortTree = (treeNodes) => {
  if (!treeNodes) {
    return []
  }
  treeNodes.sort((a, b) => {
    if (a.type === 'tree' && b.type === 'blob') {
      return -1
    }
    if (a.type === 'blob' && b.type === 'tree') {
      return 1
    }

    return a.name.localeCompare(b.name)
  })
  treeNodes.forEach((node) => {
    if (node.children && node.children.length > 0) {
      sortTree(node.children)
    }
  })

  return treeNodes
}
